import { render, staticRenderFns } from "./Starting.vue?vue&type=template&id=0445914e&scoped=true&"
import script from "./Starting.vue?vue&type=script&lang=js&"
export * from "./Starting.vue?vue&type=script&lang=js&"
import style0 from "./Starting.vue?vue&type=style&index=0&id=0445914e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445914e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0445914e')) {
      api.createRecord('0445914e', component.options)
    } else {
      api.reload('0445914e', component.options)
    }
    module.hot.accept("./Starting.vue?vue&type=template&id=0445914e&scoped=true&", function () {
      api.rerender('0445914e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Starting.vue"
export default component.exports